module.exports = __webpack_public_path__ + "img/task_send_to_assignee.1702b0c8.svg";